import { COUNTRIES } from '~/const/locales';

// Temporary products only available for delivery free in store
export var EXCLUSIVELY_FOR_STORE_DELIVERY = ['129661', '139532', '142025', '155848', '164512', '174871', '186576', '198093', '198102', '198103', '198104'];
export var RENEE_RECYCLE_PRODUCTS = ['220232', '220233', '220235', '220237', '220236', '220240', '220241', '220242', '220239', '220238', '220252', '220254', '220255', '220272', '220289', '220290', '220291', '220277', '220311', '220307', '220292', '220276', '220256', '220259', '220263', '220258', '220257', '220262', '220261', '220265', '220266', '220260', '220293', '220298', '220294', '220300', '220270', '220305', '220312', '220308', '220279', '220278', '220296', '220275', '220288', '220274', '220302', '220309', '220243', '220244', '220245', '220247', '220246', '220249', '220248', '220251', '220250', '220253', '220267', '220268', '220304', '220303', '220271', '220273', '220295', '220269', '220301', '220299', '220280', '220306', '220310', '220281', '220297', '220282', '220283', '220264', '220284', '220285', '220286', '220287'];
export var LMA_FEEDBACK = Object.freeze({
  LGM: 'LGM',
  CC: 'CC',
  NEUTRAL: 'Neutre'
});
export var LGM_MARKET_EXCLUSION = Object.freeze([COUNTRIES.PT, COUNTRIES.NL, COUNTRIES.GB]);
export var PRODUCT_STOCK_STATUS = Object.freeze({
  IN_STOCK: 'IN_STOCK',
  UNAVAILABLE: 'UNAVAILABLE',
  SOON: 'SOON',
  MONTH: 'MONTH',
  WEEK: 'WEEK',
  LIMITED: 'LIMITED',
  STORE_ONLY: 'STORE_ONLY',
  DELETE: 'DELETE'
});
export var PRODUCT_STOCK_COLORS = Object.freeze({
  [PRODUCT_STOCK_STATUS.IN_STOCK]: 'green',
  [PRODUCT_STOCK_STATUS.UNAVAILABLE]: 'red',
  [PRODUCT_STOCK_STATUS.SOON]: 'green',
  [PRODUCT_STOCK_STATUS.MONTH]: 'green',
  [PRODUCT_STOCK_STATUS.WEEK]: 'green',
  [PRODUCT_STOCK_STATUS.LIMITED]: 'green',
  [PRODUCT_STOCK_STATUS.STORE_ONLY]: 'black',
  [PRODUCT_STOCK_STATUS.DELETE]: 'white',
  default: 'black'
});